import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1bf58dd8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "home_box" }
const _hoisted_3 = { class: "home_box_left" }
const _hoisted_4 = {
  key: 0,
  class: "home_box_right"
}
const _hoisted_5 = { style: {"color":"red"} }
const _hoisted_6 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_7 = {
  key: 1,
  class: "home_box_right",
  style: {"display":"flex","flex-direction":"column","align-items":"flex-end"}
}

import { onMounted, onUnmounted, reactive, ref, watch } from "vue";
import { api_cw_get_finance_list, api_cw_balance_inquiry, api_cw_pay_check, api_cw_hd_check, api_cw_get_balance_list, api_cw_dk_cl, api_cw_jujue_dk, api_cw_single_pay } from '@/api/home';
import { api_cw_get_notice, api_cw_get_user_info } from '@/api/home'
import { message, type TableColumnsType } from 'ant-design-vue';

import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';

import type { Dayjs } from 'dayjs';

import router from "@/router";

type RangeValue = [Dayjs, Dayjs];

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

let date = ref<any>([]);


const value1 = ref<RangeValue>();
let current = ref<number>(1)
let user: any = localStorage.getItem('user') || sessionStorage.getItem('user');
user = JSON.parse(user);

let status = ref<string>('1')


watch(value1, (newValue, oldValue) => {
    if (newValue === null) {
        list.value = [];
        current.value = 1;
        total.value = 1;
    }
})

let packageNo = ref('');

let circulation: any = null;

onMounted(() => {
    // console.log('组件加载');
    api_cw_balance_inquiryFun();
    date.value[0] = dateFun(new Date().getTime() - 86400000);
    date.value[1] = dateFun(new Date().getTime());





    if (user.roule === 4) finishFun('');
    api_cw_get_noticeFun();


    // circulation = setInterval(() => {
    //     api_cw_get_noticeFun();
    // }, 5000)

});


onUnmounted(() => {
    console.log('退出');

    // clearInterval(circulation)
})






let dakuanOpen = ref(false);
let shenheOpen = ref(false);
let auditType = ref<string>('0');
let TemporaryStorage = reactive<any>({});


const MakePaymentFun = (e: any) => {
    console.log(e);

    if (e.status === '0') {
        shenheOpen.value = !shenheOpen.value;
    } else {
        dakuanOpen.value = !dakuanOpen.value;
    }
    TemporaryStorage = e.item;
};






let res = ref<any>({});
let ress = ref<any>({});

const api_cw_get_noticeFun = async () => {
    lists.value = [];
    let data: any = await api_cw_get_notice(user.openid);
    let datas = await api_cw_get_user_info(user.openid);

    res.value = data;
    ress.value = datas;

    if (data.order.length !== 0) {
        data.order.forEach((item: any) => {
            let obj = {
                recAccNo: item.recAccNo,
                recAccName: item.recAccName,
                isSameBank: item.isSameBank === '1' ? '否' : '是',
                amount: item.amount,
                memo: item.memo,
                recBankNo: item.recBankNo ? item.recBankNo : '-',
                recBankName: item.recBankName ? item.recBankName : '-',
                status_name: item.status_name,
                status: item.status,
                time: item.time,
                item
            }
            lists.value.push(obj)
        })
    }

    console.log(data);

    console.log(data, datas);
}
const handleChange = (e: any) => {
    console.log(e);
}
const focus = (e: any) => {
    console.log(e);
}
const paginationChange = (e: any) => {

    current.value = e.current;
    console.log(e, '--------------------------------------------------');

    finishFun('');
}



let usableBalance = ref(0);
let balance = ref(0);
let lastDayBalance = ref(0);

let zhuanzhangFun = () => {
    if (auditType.value === '0') {
        api_cw_jujue_dkFun()
    } else {
        api_cw_single_payFun()
    }
}

//同意打款
const api_cw_single_payFun = async () => {
    let up = {
        payAccName: user.payAccName,
        payAccNo: user.payAccNo,
        recAccName: TemporaryStorage.recAccName,
        recAccNo: TemporaryStorage.recAccNo,
        amount: TemporaryStorage.amount,
        isSameBank: TemporaryStorage.isSameBank,
        recBankNo: TemporaryStorage.recBankNo,
        recBankName: TemporaryStorage.recBankName,
        openid: user.openid,
        memo: TemporaryStorage.memo,
        id: TemporaryStorage.id
    }
    let data: any = await api_cw_single_pay(up);
    console.log(data);
    if (data.error === 0) {
        api_cw_get_noticeFun();
    }
    dakuanOpen.value = !dakuanOpen.value;
    auditType.value = '0'
};

//取消或拒绝
let api_cw_jujue_dkFun = async () => {
    let up = {
        openid: user.openid,
        id: TemporaryStorage.id
    }
    let data: any = await api_cw_jujue_dk(up);
    if (data.error === 0) {
        // api_cw_get_zd_listFun();
        api_cw_get_noticeFun();
    }
    dakuanOpen.value = !dakuanOpen.value;
    auditType.value = '0'

}

const open = ref<boolean>(false);


const showModal = () => {
    open.value = true;
};

const handleOk = (e: MouseEvent) => {
    console.log(e);
    open.value = false;
};





const popconfirmConfirmFun = async (res: any) => {
    console.log(res.transSeqNb);
    let up = {
        openid: user.openid,
        transSeqNb: res.transSeqNb
    }
    let data: any = await api_cw_dk_cl(up);
    if (data.error === 0) {
        finishFun('');
    }

}
const popconfirmCancelFun = async () => {
    message.error('已取消')
}







const api_cw_balance_inquiryFun = async () => {
    let data: any = await api_cw_balance_inquiry(user.payAccNo, user.openid);
    usableBalance.value = data.usableBalance
    balance.value = data.balance
    lastDayBalance.value = data.lastDayBalance
    console.log(data);


}

// const columns: TableColumnsType = [
//     { title: '转账账号', width: 100, dataIndex: 'recAccNo' },
//     { title: '开户名', width: 100, dataIndex: 'recAccName' },
//     { title: '银行名称', width: 100, dataIndex: 'recBankName' },
//     { title: '转账金额', width: 100, dataIndex: 'amount' },
//     { title: '订单号', width: 100, dataIndex: 'packageNo' },
//     { title: '操作时间', width: 100, dataIndex: 'time' },
//     { title: '状态', width: 100, dataIndex: 'message' },
//     { title: '操作', width: 100, dataIndex: 'Controls' }
// ];


const ReceiptQueryFun = async (item: any) => {
    console.log(item);
    let up = {
        openid: user.openid,
        // accNo: item.recAccNo,
        accNo: user.payAccNo,
        retNo: item.retNo
    }
    let data: any = await api_cw_hd_check(up);
    if (data.error === 0) {
        base64ToPDF('data:application/pdf;base64,' + data.body.billFileContent, 'example.pdf')
    }
}


const column: TableColumnsType = [
    // { title: '收款人账号', dataIndex: 'recAccNo' },
    { title: '收款户名', dataIndex: 'recAccName' },
    // { title: '是否跨行', dataIndex: 'isSameBank' },
    { title: '打款金额', dataIndex: 'amount' },
    // { title: '附言', dataIndex: 'memo' },
    // { title: '行号', dataIndex: 'recBankNo' },
    { title: '银行名称', dataIndex: 'recBankName' },
    { title: '状态', dataIndex: 'status_name' },
    { title: '操作时间', dataIndex: 'time' },
    {
        title: '操作', dataIndex: 'Controls',
    },
];

const columns = [
    {
        title: '交易金额',
        dataIndex: 'amount',
        // width: '15%',
    },
    {
        title: '状态',
        dataIndex: 'drcType',
        width: '100px'
    },
    {
        title: '对方账户名称',
        dataIndex: 'recAccName',
        // width: '15%',
    },
    {
        title: '对方账号',
        dataIndex: 'recAccNo',
        // width: '15%',
    },
    {
        title: '交易流水号',
        dataIndex: 'transSeqNb',
        width: '15%',
    },
    {
        title: '交易日期',
        dataIndex: 'tranDt',
        width: '140px',
    },
    {
        title: '附言',
        dataIndex: 'memo'
    },
    {
        title: '操作',
        dataIndex: 'Controls',
        // width: '15%',
    }
];



const base64ToPDF = (base64String: string, pdfName: string) => {
    let binaryData = atob(base64String.split(',')[1]);
    let mimeString = base64String.split(',')[0].split(':')[1];
    let arrayBuffer = new ArrayBuffer(binaryData.length);
    let uintArray = new Uint8Array(arrayBuffer);
    for (let i = 0; i < binaryData.length; i++) {
        uintArray[i] = binaryData.charCodeAt(i);
    }
    let blob = new Blob([uintArray], { type: mimeString });
    let url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    a.download = pdfName || 'downloadedPDF.pdf';
    // 触发下载
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}








const columnss: TableColumnsType = [
    { title: '转账账号', width: "30%", dataIndex: 'recAccNo' },
    { title: '转账金额', width: "15%", dataIndex: 'amount' },
    { title: '转账状态', width: "30%", dataIndex: 'desc' },
]

let list: any = ref([]);
let lists: any = ref([]);
let dataSource: any = ref([]);

let total: any = ref(1);

const TheInverseDateFun = (str: string): string => {
    let year = str.slice(0, 4) + '年';
    let month = str.slice(4, 6) + '月';
    let day = str.slice(6, 8) + '日';
    let hour = str.slice(8, 10) + '时';
    let minute = str.slice(10, 12) + '分';
    let second = str.slice(12, 14) + '秒';
    return year + month + day + hour + minute + second
}


const finishFun = async (value: any) => {

    list.value = [];
    let up = {
        accNo: user.payAccNo,  //查询银行账号
        pageNo: current.value, //分页 （从1开始）
        beginDate: date.value[0],  //开始时间
        endDate: date.value[1], //结束时间
        openid: user.openid
    }
    let data: any = await api_cw_get_balance_list(up);
    console.log(data);
    if (data) {
        // return
        if (data.header.code === "000000") {
            total.value = data.body.totalNum;
            data.body.details.forEach((item: any) => {
                let obj = {
                    amount: item.amount / 100,
                    recAccNo: item.recAccNo,
                    recAccName: item.recAccName,
                    transSeqNb: item.transSeqNb,
                    tranDt: TheInverseDateFun(item.tranTime),
                    retNo: item.retNo,
                    drcType: item.drcType === 'D' ? '支出' : '收入',
                    memo: item.memo,
                    status: item.status
                }
                list.value.push(obj)
            })
            // for (let index = 0; index < 40; index++) {
            //     const element = data.body.details[0];
            //     // console.log(element);
            //     list.value.push(element)

            // }
        } else {
            if (data.header.msg) message.error(data.header.msg);
        }
    }
}


let pickerChangeFun = (e: any) => {
    console.log(e);

    if (e === null) {
        date.value[0] = dateFun(new Date().getTime() - 86400000);
        date.value[1] = dateFun(new Date().getTime());
        return
    }
    if (date.value.length === 2) {
        date.value = []
    }
    for (let index = 0; index < e.length; index++) {
        const element = e[index].$d;
        console.log(element);
        let str = dateFun(Date.parse(element))
        date.value.push(str);
    }
}

const StatusQueryFun = async (item: any) => {
    console.log(item);
    dataSource.value = [];

    let up = {
        openid: user.openid,
        queryPacNo: item.packageNo
    }
    console.log(up);

    let data: any = await api_cw_pay_check(up);
    if (data.header.code === '000000') {
        if (data.body.details.length !== 0) {
            open.value = true;
            data.body.details.forEach((item: any) => {

                let obj = {
                    recAccNo: item.recAccNo,
                    amount: item.amount / 100,
                    desc: item.desc
                }
                dataSource.value.push(obj);
            });
            console.log(dataSource.value);
        }
    }
}

const dateFun = (timestamp: number): string => {

    var date = new Date(timestamp);
    var year = date.getFullYear();
    var month = (date.getMonth() + 1).toString().padStart(2, '0');
    var day = date.getDate().toString().padStart(2, '0');

    return `${year}${month}${day}`
}


return (_ctx: any,_cache: any) => {
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_descriptions, {
      bordered: "",
      size: "small",
      column: 2
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_descriptions_item, { label: "账户名称" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(user).payAccName), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_a_descriptions_item, { label: "卡号" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(user).payAccNo), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_a_descriptions_item, { label: "余额" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(balance)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_a_descriptions_item, { label: "当前可用余额" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(usableBalance)), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_a_descriptions, {
          column: 1,
          bordered: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_descriptions_item, { label: "用户名称" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(ress).conpey_name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "用户账号" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(ress).mobile), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "上次登录时间" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(ress).last_login_time), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "登录次数" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(ress).login_num), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      ((_unref(user).roule === 1 || _unref(user).roule === 4) ? false : true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_a_card, {
              title: `待办事项${_unref(res).daiban}`,
              style: {"width":"100%","height":"20%"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(res).tixing), 1)
              ]),
              _: 1
            }, 8, ["title"]),
            _createVNode(_component_a_card, {
              title: "快速审批",
              style: {"width":"100%","height":"50%","margin-top":"20px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_table, {
                  class: "components-table-demo-nested",
                  columns: column,
                  "data-source": _unref(lists),
                  border: "",
                  scroll: { y: 200 },
                  pagination: false
                }, {
                  bodyCell: _withCtx(({ column, record }) => [
                    (column.dataIndex === 'amount')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(record.amount), 1))
                      : _createCommentVNode("", true),
                    (column.dataIndex === 'Controls')
                      ? (_openBlock(), _createBlock(_component_a_space, {
                          key: 1,
                          warp: ""
                        }, {
                          default: _withCtx(() => [
                            ((_unref(user).roule === 3 || _unref(user).roule === 0))
                              ? (_openBlock(), _createBlock(_component_a_button, {
                                  key: 0,
                                  type: "primary",
                                  disabled: record.status === '1' ? false : true,
                                  onClick: ($event: any) => (MakePaymentFun(record))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" 去审核 ")
                                  ]),
                                  _: 2
                                }, 1032, ["disabled", "onClick"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["data-source"])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_unref(user).roule === 4)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_a_form, {
              layout: "inline",
              style: {"margin":"10px 0"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, { label: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_range_picker, {
                      value: value1.value,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((value1).value = $event)),
                      "show-time": { format: 'HH:mm' },
                      locale: _unref(locale),
                      format: "YYYY-MM-DD HH:mm",
                      onChange: _unref(pickerChangeFun)
                    }, null, 8, ["value", "locale", "onChange"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      onClick: finishFun
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("搜索")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_table, {
              columns: columns,
              "data-source": _unref(list),
              scroll: { y: '540px' },
              onChange: paginationChange,
              pagination: { total: _unref(total), current: _unref(current), pageSize: 10 }
            }, {
              bodyCell: _withCtx(({ column, record }) => [
                (column.dataIndex === 'Controls')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (record.retNo !== '')
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 0,
                            style: {"width":"100px","margin-bottom":"10px"},
                            type: "primary",
                            onClick: ($event: any) => (ReceiptQueryFun(record))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("下载回单")
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true),
                      (record.drcType !== '支出')
                        ? (_openBlock(), _createBlock(_component_a_popconfirm, {
                            key: 1,
                            title: "是否确认操作?",
                            "ok-text": "确认",
                            "cancel-text": "取消",
                            onConfirm: ($event: any) => (popconfirmConfirmFun(record)),
                            onCancel: popconfirmCancelFun,
                            disabled: record.status === '已处理'
                          }, {
                            default: _withCtx(() => [
                              (record.retNo !== '')
                                ? (_openBlock(), _createBlock(_component_a_button, {
                                    key: 0,
                                    style: {"width":"100px"},
                                    type: "primary"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(record.status === "已处理" ? "已处理" : '确认打款'), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["onConfirm", "disabled"]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["data-source", "pagination"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_a_modal, {
      open: _unref(dakuanOpen),
      "onUpdate:open": _cache[2] || (_cache[2] = ($event: any) => (_isRef(dakuanOpen) ? (dakuanOpen).value = $event : dakuanOpen = $event)),
      title: "确认转账吗？确认后金额立即转出",
      okText: "确认",
      cancelText: "关闭",
      onOk: _unref(zhuanzhangFun)
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_space, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_select, {
              ref: "select",
              value: _unref(auditType),
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_isRef(auditType) ? (auditType).value = $event : auditType = $event)),
              style: {"width":"120px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select_option, { value: "1" }, {
                  default: _withCtx(() => [
                    _createTextVNode("同意")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_select_option, { value: "0" }, {
                  default: _withCtx(() => [
                    _createTextVNode("拒绝")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["open", "onOk"])
  ]))
}
}

})